import { defineStore } from 'pinia'
import { reactive } from 'vue'
type DialogName = 'packageProgress' | 'prodAlert' | 'systemInfoAlert'

export const usePermanentDialog = defineStore('permanentDialog', () => {
  const dialogs = reactive<Record<DialogName, { isOpen: boolean; data: any }>>({
    packageProgress: { isOpen: false, data: null },
    prodAlert: { isOpen: false, data: null },
    systemInfoAlert: { isOpen: false, data: null },
  })

  const openDialog = (dialogName: DialogName, data?: any) => {
    dialogs[dialogName].isOpen = true
    dialogs[dialogName].data = data || null
  }
  const closeDialog = (dialogName: DialogName) => {
    dialogs[dialogName].isOpen = false
    dialogs[dialogName].data = null
  }

  return { dialogs, openDialog, closeDialog }
})
